import { CurrencyHackData, getCurrency } from "./currencyHack";

export function useNumberFormatHack(provider) {
  class NumberFormatHack extends Intl.NumberFormat {
    constructor(locales, options) {
      if (options.style != "currency" || options.currency === undefined) return super(locales, options);

      let thingy = CurrencyHackData[provider] || CurrencyHackData.default;
      options.currency = options.currency.toUpperCase();
      let hack = thingy[options.currency] || CurrencyHackData.default[options.currency];

      // Regardless of requested options, currency formatting is limited at most 2dp
      // due to backend restrictions.
      options.maximumFractionDigits = getCurrency(options.currency, locales, provider).decimalPlaces;

      if (hack == undefined) return super(locales, options);

      // Modify currency symbol
      let fmt = super(locales, { ...options, currency: hack.currency });
      return {
        format: function (val) {
          return fmt.format(val).replace(hack.symbolRegexp, hack.symbol);
        },
      };
    }
  }

  Intl.NumberFormat = NumberFormatHack;
}
